import React from 'react';
import UserBalanceDetails from '../components/management/UserBalanceDetails';

const UserBalanceDetailsPage = () => {
    return <UserBalanceDetails />;
};

export default UserBalanceDetailsPage;
